import { render, staticRenderFns } from "./SearchDirectionDeliveryShao.vue?vue&type=template&id=53fa3a70"
import script from "./SearchDirectionDeliveryShao.vue?vue&type=script&lang=js"
export * from "./SearchDirectionDeliveryShao.vue?vue&type=script&lang=js"
import style0 from "./SearchDirectionDeliveryShao.vue?vue&type=style&index=0&id=53fa3a70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports